export default __webpack_public_path__ + "static/media/WM0490.34I-43621_-26041_0.8f1e2e43.jpg";